import { render, staticRenderFns } from "./Conifer.vue?vue&type=template&id=810590b8"
import script from "./Conifer.vue?vue&type=script&lang=js"
export * from "./Conifer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports